import React from 'react';
import styled from '@emotion/styled';
import { SButton, SIcon, type SButtonProps } from '@chargebee/sting-react';
import { CloseButton } from '@bbkAdminComponents/buttons/close-button';
import {
  RevertButton,
  SaveButton,
} from '@bbkAdminComponents/buttons/save-actions';
import { cs } from '@bbkAdminUtils/css-utils';

export const Done: React.FC<
  SButtonProps & { disabled?: boolean; label?: string }
> = ({
  onClick,
  disabled = false,
  label = 'Done',
  children,
  className,
  ...props
}) => (
  <SaveButton
    onClick={onClick}
    disabled={disabled}
    showIcon={!children}
    className={className}
    {...props}
  >
    {children ?? label}
  </SaveButton>
);

export const CloseOverlay = CloseButton;

export const Revert: React.FC<SButtonProps> = (props) => (
  <RevertButton {...props} />
);

export const CopyShareLink: React.FC<SButtonProps> = ({
  onClick,
  className,
  ...props
}) => (
  <SButton
    variant="neutral-outline"
    onClick={onClick}
    icon={<SIcon name="link" />}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    Copy share link
  </SButton>
);

export const Publish: React.FC<SButtonProps> = ({
  onClick,
  children,
  className,
  ...props
}) => (
  <SButton
    variant="primary"
    onClick={onClick}
    icon={<SIcon name="cloud-upload" />}
    className={cs('tw-flex tw-items-center', className)}
    {...props}
  >
    {children ?? 'Publish'}
  </SButton>
);

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dddfe2;
  background: #fff;
  min-height: 60px;
  position: sticky;
  top: 0;
  z-index: 20;
`;
